import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchCategories({ params, callbacks }) {
  try {
    const response = yield call(api.fetchCategories, params);
    yield put(Actions.fetchCategoriesSuccess(response.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.fetchCategoriesFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchFetchCategories() {
  yield takeLatest(Actions.FETCH_CATEGORIES_REQUEST, fetchCategories);
}

export default function* list() {
  yield all([fork(watchFetchCategories)]);
}
